import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllMasterSchedule extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterSchedule/GetAllV2ForMaster");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class CreateMasterScheduleByList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterSchedule/CreateBy");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteMasterScheduleByList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterSchedule/DeleteBy");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class ValidDatesForMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterSchedule/ValidDateForMaster");
  }
}

export {
  GetAllMasterSchedule,
  CreateMasterScheduleByList,
  DeleteMasterScheduleByList,
  ValidDatesForMaster,
};
